module.exports = __webpack_public_path__ + "3367c489425329a2f5c1531ecc388c6a.mp3";


//////////////////
// WEBPACK FOOTER
// ./sounds/man.mp3
// module id = 824
// module chunks = 0